import type { PropsWithChildren } from 'react'

import { CostSummary } from '@webapp/core/components/CostSummary'
import { BudgetCategoryCardGranularSpendRow } from '../BudgetCategoryCardGranularSpendRow'
import { BudgetCategoryCardGranularSpendStyled } from './styles/BudgetCategoryCardGranularSpendStyled'

interface IBudgetCategoryCardGranularSpend {
  ariaLabel?: string
}

export const BudgetCategoryCardGranularSpend = ({
  ariaLabel,
  children,
}: PropsWithChildren<IBudgetCategoryCardGranularSpend>) => {
  return (
    <BudgetCategoryCardGranularSpendStyled>
      <CostSummary ariaLabel={ariaLabel}>{children}</CostSummary>
    </BudgetCategoryCardGranularSpendStyled>
  )
}

BudgetCategoryCardGranularSpend.displayName = 'BudgetCategoryCardGranularSpend'
BudgetCategoryCardGranularSpend.Row = BudgetCategoryCardGranularSpendRow
